export default "__VITE_ASSET__5169dfae__"